module.exports = __webpack_public_path__ + "static/media/history.84b034fb.png";